let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ece3U")).then(() => parcelRequire('lp0fk'));